import { Stack } from "@mui/material";
import { Form } from "./components/form";

/**
 * Conteúdo de família no dashboard (ScreenMobile) e fluxos embutidos.
 * Listas usam ResponsiveGenericTable — cards no mobile, tabela no web.
 */
export function MyfamilyForDash() {
  return (
    <Stack sx={{ width: "100%", pb: 1 }} spacing={1.5}>
      <Form />
    </Stack>
  );
}
